/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IconStateConfig,
  IconStateConfig$inboundSchema,
  IconStateConfig$Outbound,
  IconStateConfig$outboundSchema,
} from "./iconstateconfig.js";

/**
 * A single icon to display
 */
export type EBIcon = {
  /**
   * The name of the icon. This is used to identify the icon in the client, ideally it should be unique.
   */
  name?: string | undefined;
  /**
   * The states of the icon
   */
  states: Array<IconStateConfig>;
};

/** @internal */
export const EBIcon$inboundSchema: z.ZodType<EBIcon, z.ZodTypeDef, unknown> = z
  .object({
    name: types.optional(types.string()),
    states: z.array(IconStateConfig$inboundSchema),
  });
/** @internal */
export type EBIcon$Outbound = {
  name?: string | undefined;
  states: Array<IconStateConfig$Outbound>;
};

/** @internal */
export const EBIcon$outboundSchema: z.ZodType<
  EBIcon$Outbound,
  z.ZodTypeDef,
  EBIcon
> = z.object({
  name: z.string().optional(),
  states: z.array(IconStateConfig$outboundSchema),
});

export function ebIconToJSON(ebIcon: EBIcon): string {
  return JSON.stringify(EBIcon$outboundSchema.parse(ebIcon));
}
export function ebIconFromJSON(
  jsonString: string,
): SafeParseResult<EBIcon, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EBIcon$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EBIcon' from JSON`,
  );
}
